module.exports = __webpack_public_path__ + "static/media/userTie.aebf3287.svg";